import Cookies from 'js-cookie'
import * as Lockr from 'lockr'
import { clearCookies, clearLocalStorage } from '../logout-utils'
import { logNewRelicEvent } from '../common/custom/newrelic-page-events'
import { onLogin } from '../login/on-login'
import { ErrorNRLogs } from '../network-adapter/error.tracking'
import { refreshTokenUrl } from '@/root/api/apiConstants'
import { HTTP_STATUS_CODE } from '@/root/constants/api-status-codes'
import { setSessionId } from '../login/get-session-id'

export const handleLogout = (clearCookiesAndLS: boolean = true) => {
  if (clearCookiesAndLS) {
    clearCookies()
    clearLocalStorage()
  }
  window.location.href = `/login?return_to=${window.location.pathname.substring(
    0,
    1000,
  )}${window.location.search.substring(0, 1000)}`
}

export const handleRefreshToken = async (clearCookiesAndLS: boolean = true) => {
  try {
    const refreshToken = Cookies.get('refresh_token') ?? ''
    if (!refreshToken) {
      // if refresh_token is not present, then we need to logout the user
      handleLogout(clearCookiesAndLS)
      return null
    }

    const refreshTokenResp = await fetch(refreshTokenUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    })
    const refreshTokenRespJson = await refreshTokenResp.json()
    if (refreshTokenResp.status === HTTP_STATUS_CODE.SUCCESS) {
      logNewRelicEvent(ErrorNRLogs.webRefreshTokenSuccess, {
        statusCode: refreshTokenResp.status.toString(),
        url: refreshTokenUrl,
        apiType: 'REFRESH_TOKEN',
      })
      // if API call is a success, then we need to set new Token in cookies and localStorage and verify new Encrypted Token on INDstocks (in onLogin())
      const newToken = refreshTokenRespJson.jwt_token
      const newEncryptedToken = refreshTokenRespJson.encrypted_token
      Lockr.set('token', newToken)
      Cookies.set('token', newToken, { secure: true })
      setSessionId()
      onLogin(false, newEncryptedToken, window.location.pathname)
      return newToken
    } else if (refreshTokenResp.status === HTTP_STATUS_CODE.BAD_REQUEST) {
      logNewRelicEvent(ErrorNRLogs.webRefreshTokenBadRequestError, {
        error: JSON.stringify(refreshTokenRespJson),
        statusCode: refreshTokenResp.status.toString(),
        url: refreshTokenUrl,
        apiType: 'REFRESH_TOKEN',
      })
    } else {
      handleLogout(clearCookiesAndLS)
    }
  } catch (error: unknown) {
    logNewRelicEvent(ErrorNRLogs.webRefreshTokenError, {
      error: JSON.stringify(error),
      url: refreshTokenUrl,
    })
    handleLogout(clearCookiesAndLS)
  }
  return null
}
